import { Fragment, memo } from "react";
import { useParams } from "react-router-dom";

import TimeInputPopup from "../components/shared/TimeInput/TimeInputPopup";
import { useSelector } from "../redux/hooks";
import { MEDLBID } from "../utils";
import BodyPartModal from "./_Medical/BodyPart/BodyPartModal";
import BodyPartPreviewModal from "./_Medical/BodyPart/BodyPartPreviewModal";
import CaseReportModal from "./_Modals/CaseReportModal/CaseReportModal";
import CheckListsModal from "./_Modals/CheckListsModal/CheckListsModal";
import RefetchModal from "./_Modals/RefetchModal/RefetchModal";
import URNHistoryModal from "./_Modals/URNHistoryModal/URNHistoryModal";
import Autofill from "./Autofill/Autofill";
import UnitConverterModal from "./Converter/UnitConverterModal";
import IlTableModal from "./ilInput/IlTableModal";
import DeisolatedTimeModal from "./_Modals/DeisolatedTimeModal/DeisolatedTimeModal";
import NMEAAutomationModal from "./_Modals/NMEAAutomationModal/NMEAAutomationModal";
interface Props {
  refetchLogbook: () => void;
}
const Modals = ({ refetchLogbook }: Props) => {
  const { logbookId } = useParams();
  const { timeInputPopup } = useSelector(state => state.generatorFeaturesSlice);
  const isMedical = logbookId === MEDLBID;
  return (
    <Fragment>
      <RefetchModal refetch={refetchLogbook} />
      <CheckListsModal type="entry" />
      <IlTableModal />
      <UnitConverterModal />
      <URNHistoryModal />
      {timeInputPopup && <TimeInputPopup />}
      <Autofill />
      {isMedical && (
        <Fragment>
          <BodyPartPreviewModal />
          <BodyPartModal />
          <CaseReportModal />
        </Fragment>
      )}
      <DeisolatedTimeModal />
    </Fragment>
  );
};
export default memo(Modals);
